import React from "react";
import { Link } from "react-router-dom";
import "./CopyRight.css";

const CopyRight = () => {
  return (
    <div className="footer-base">
      <div className="allcopy">
        <span>© 2024 Web5Solution. All Rights Reserved</span>

        <Link className="privacy" to="/privacy-policy">
          • Privacy Policy
        </Link>

        <Link className="privacy" to="/terms-and-conditions">
          • Terms & Conditions
        </Link>
      </div>
    </div>
  );
};

export default CopyRight;